module.exports = __webpack_public_path__ + "img/gld_gbt834_1988.prt.7e51236a.jpg";